<template>
  <b-container
    fluid
    class="p-2 layout-container"
  >
      <!-- <b-breadcrumb :items="breadcrumbs"></b-breadcrumb> -->

    <AppLoader
      v-if="$store.state.isLoading"
      small
    />
    
    <b-row v-else>
      <b-col cols="6">
        <h2>{{form.formTitle ? form.formTitle['english'] : 'Form title has not been set'}}</h2>
      </b-col>
      <b-col cols="2">
      </b-col>
      <b-col
        cols="2"
        class="bg-red"
      >
        <p
          style="font-size: 12px; color:grey;"
          v-if="lastUpdatedTime"
        >Last Updated: {{lastUpdatedTime}}</p>
      </b-col>
      <b-col cols="2">
        <b-button
          :disabled="isLoading || isLoadingLocal"
          @click="onSaveJsonData()"
          variant="outline-success"
          class="mr-1"
          size="sm"
        >
          <span v-if="isLoading || isLoadingLocal">
            <b-spinner
              small
              type="grow"
            ></b-spinner>Saving...
          </span>
          <span v-else>Save Form</span>
        </b-button>
        <b-button
          variant="outline-danger"
          size="sm"
          v-if="isPublished!=1"
          @click="showModalFormPublish=true"
        >Publish</b-button>
        <!-- <b-button variant="outline-danger" size="sm" @click="showModalFormPublish=true">Publish</b-button> -->
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <router-link
              to="/form/configuration"
              :class="currentRoute === 'config' ? 'nav-link active' : 'nav-link' "
            >Configuration</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/form/details"
              :class="currentRoute === 'details' ? 'nav-link active' : 'nav-link' "
            >Details</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/form/intro"
              :class="currentRoute === 'intro' ? 'nav-link active' : 'nav-link' "
            >Intro</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/form/builder"
              :class="currentRoute === 'builder' ? 'nav-link active' : 'nav-link' "
            >Builder</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/form/json"
              :class="currentRoute === 'json' ? 'nav-link active' : 'nav-link' "
            >JSON</router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/form/settings"
              :class="currentRoute === 'settings' ? 'nav-link active' : 'nav-link' "
            >Attributes</router-link>
          </li>
        </ul>
      </b-col>
    </b-row>
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <b-modal
      id="modal-2"
      v-model="showModalFormPublish"
      modal-header-close="No"
      ok-title="Publish"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      title="Alert.!"
      @ok="publishForm"
      @hidden="showModalFormPublish = false"
    >
      <p>Are you sure you want to publish this form?</p>
      <strong>Note:</strong>Once this form published, you may not be able to add, edit or delete any field or section.
      Only settings can be updated.
      <p></p>
    </b-modal>
    <AppLoaderModal
      isMulti
      content="Processing your request..."
      content2="Building your form..."
      content3="Publishing your form..."
    />
  </b-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import _ from "lodash";
import { Helper } from "@/helpers";
import { HTTP } from "@/utils/HTTP";
import { EventBus } from "@/event-bus.js";
import AppLoaderModal from "@/components/Loader/LoaderModal";
import AppLoader from "@/components/Loader/Loader";

import uid from "uid";
import moment from "moment";
export default {
  name: "FormPage",
  components: {
    AppLoaderModal,
    AppLoader,
  },
  data () {
    return {
      showModalFormPublish: false,
      isPublished: 0,
      isAutoUpdate: 0,
      activeTab: null,
      isBuilder: false,
      pushsing: null,
      lastUpdateInterval: null,
      isLoadingLocal: false,
      lastUpdatedTime: null,
      currentRoute: this.$route.name,
      //     breadcrumbs: [
      //   {
      //     text: 'All forms',
      //     href: "/employee-onboarding"
      //     // href: "/dashboard"
      //   },

      //   {
      //     text: 'Form Builder',
      //     active: true
      //   }
      // ],
    };
  },
  computed: {
    ...mapGetters( {
      form: "form1",
      isLoading: "isLoading",
    } ),
  },

  created () {
    this.pushUpdate();
  },

  async beforeCreate () {
    let formId = await localStorage.getItem( "activeFormId" );
    if ( !this.form.formId ) {
      this.getForm( formId );
    }

    //@Mohsin why do we need this here?
    await EventBus.$on( "onAutoSaveJsonForm", ( value ) => {
      if ( this.$route.name != "templates" ) {
        // console.log("Auto Saving Data in Form page...");
        // this.onSaveJsonData(value);
      }
    } );
  },

  beforeRouteLeave ( two, from, next ) {
    // console.log("beforeRouteLeave form.vue");
    this.onResetLocalData();
    this.lockUnlockForm( 0 );
    next();
  },

  watch: {
    currentRoute ( route ) {
      // console.log("route", route);
    },
    $route ( to, from ) {
      this.currentRoute = this.$route.name;
    },
  },

  mounted () {
    console.log( "-in RSFORM-" )
    //this.clearFields();
  },

  methods: {
    ...mapMutations( ["ADD_SECTION", "UPDATE_FORM", "ADD_TEMP_FORM"] ),

    ...mapActions( ["removeSection", "cloneSection"] ),

    onResetLocalData () {
      localStorage.removeItem( "taskId" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "examAttemptsToDate" );
      localStorage.removeItem( "examAttemptId" );
      localStorage.removeItem( "tempForm" );
      localStorage.removeItem( "activeFormId" );
      localStorage.removeItem( "userConsent" );
      localStorage.removeItem( "clientId" );
    },

    async lockUnlockForm ( status ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let activeFormId = localStorage.getItem( "activeFormId" )
        ? localStorage.getItem( "activeFormId" )
        : this.$store.state.form1.formId;
      let userId = localStorage.getItem( "userId" );
      try {
        await HTTP(
          "put",
          "api/v1/form/lockstatus/" + activeFormId,
          {
            userId: userId,
            lockStatus: status,
          },

          {
            Authorization: token,
          },
          null,
          true
        );
      } catch ( error ) {
        return error;
      }
    },

    clearFields () {
      if ( this.$store.state.form1 && this.$store.state.form1.formSection && this.$store.state.form1.formSection.length ) {
        this.$store.state.form1.formSection.map( ( sec ) => {
          sec.formElements.map( ( ee ) => {
            if ( ee.inputType == "signature" ) {
              ee.data = {
                signatureValue: null,
                nameValue: null,
                dateValue: null,
              };
            }
            ee.value = null;
            ee.selected = null;
          } );
        } );
      }

    },

    async publishForm () {
      // console.log("------------");
      this.onSaveJsonData( true );
      this.$store.state.isLoadingMulti = true;
      let formId = await localStorage.getItem( "activeFormId" );
      if ( formId ) {
        let token = "Bearer " + localStorage.getItem( "accessToken" );
        let result = await HTTP( "put", "api/v1/form/publish/" + formId, null, {
          Authorization: token,
        } );
        let self = this;
        setTimeout( function () {
          self.$store.state.isLoadingMulti = false;
          if ( result.data.success == 1 ) {
            Helper.makeToast( self.$bvToast, "success", "Form Publish Success" );
            self.$router.replace( "/employee-onboarding" );
          } else {
            Helper.makeToast(
              self.$bvToast,
              "danger",
              "Form Publish Fail, please try again.."
            );
          }
        }, 9000 );
      }
    },

    pushUpdate () {
      // console.log("pushUpdate check for auto update", this.isAutoUpdate);
      if ( this.isAutoUpdate == 1 ) {
        let formId = localStorage.getItem( "activeFormId" );
        if ( this.$route.name != "templates" && formId ) {
          this.pushsing = setInterval( () => {
            let compareForms = _.isEqual( this.form, this.$store.state.tempForm );
            if ( !compareForms ) {
              this.onSaveJsonData();
            }
          }, 180000 );
        }
      }
    },

    // setLastUpdateInterval() {
    //   this.lastUpdateInterval = setInterval(() => {
    //     return this.lastUpdatedTime;
    //   }, 3000);
    // },

    async getForm ( formId ) {
      this.$store.state.isLoading = true;
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "get",
        "api/v1/form/" + formId,
        null,
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.form && result.data.form.schema ) {
        this.isPublished = JSON.parse( result.data.form.is_active );
        this.isAutoUpdate = result.data.form.is_auto_update
          ? JSON.parse( result.data.form.is_auto_update )
          : 1;
        var form = JSON.parse( result.data.form.schema );
        if(result.data.form.related_form_ids) {
            let related_form_ids = JSON.parse( result.data.form.related_form_ids );
            if(related_form_ids) {
              let linkedTraining = null;
              let linkedExam = null;
              related_form_ids.map(
                ( item, index ) => {
                  if ( item && item.type && item.type == 8) {
                    linkedTraining = item;
                  } else if ( item && item.type && item.type == 4) {
                    linkedExam = item;
                  }
                }
              );
              if(linkedTraining) {
                Object.assign( form, { linkedTraining } );
              }
              if(linkedExam) {
                Object.assign( form, { linkedExam } );
              }
            }
        }
        
        form.onboardingFormTypeId = result.data.form.onboarding_form_type_id;
        // console.log( 'result.data.form.onboarding_form_type_id ', result.data.form.onboarding_form_type_id )
        let onboarding_form_type_id = result.data.form.onboarding_form_type_id
        let cloneForm = _.cloneDeep( form );
        this.ADD_TEMP_FORM( cloneForm );
        this.updateFormToStore( form );
        this.$store.state.isLoading = false;
        this.grtPdfForms( onboarding_form_type_id );
        this.getTrainingTests( onboarding_form_type_id );
      }
    },

    async getTrainingTests ( onboarding_form_type_id ) {
      // console.log( this.$store.state.form1.clientId, 'companyIDDD' )
      try {
        let result = await HTTP( "post", "api/v1/getpracticeexams", {
          company_id: onboarding_form_type_id,
        } );
        if (
          result.data &&
          result.data.practiceexams &&
          result.data.practiceexams.length
        ) {
          this.$store.state.practiceExams = result.data.practiceexams;
        }
      } catch ( error ) {
        console.log( "error----", error );
      }
    },

    async grtPdfForms ( onboarding_form_type_id ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      // let company_id = this.form1.clientId;
      // let company_id = clientId;
      let form_type = 6;
      let url = `api/v1/getforms/${onboarding_form_type_id}/${form_type}`;

      let result = await HTTP(
        "get",
        url,
        null,
        {
          Authorization: token,
        },
        null,
        false
      );
      this.$store.state.pdfForms = result.data.forms;
    },

    updateFormToStore ( form ) {
      console.log(form,"chec form key")
      this.UPDATE_FORM( form );
      EventBus.$emit( "getPdsForms", "e" );
      this.$store.state.isLoading = false;
    },

    addSection ( length, type ) {
      let id = uid();
      let newSection;
      let title;
      this.sectionLength = length;
      switch ( type ) {
        case "directors-section":
          title = "Directors section " + ( length + 1 ) + " Title";
          newSection = {
            type: "directors",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "address",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelAddress1: {
                      english: "Address1",
                    },
                    labelAddress2: {
                      english: "Address2",
                    },
                    labelCity: {
                      english: "City",
                    },
                    labelState: {
                      english: "State",
                    },
                    labelZip: {
                      english: "Zip",
                    },
                    selectedState: null,
                    optionsState: [
                      { value: "", text: "State 1" },
                      { value: "", text: "State 2" },
                    ],
                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "address-section":
          title = "Address section " + ( length + 1 ) + " Title";
          newSection = {
            type: "address",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "address",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelAddress1: {
                      english: "Address1",
                    },
                    labelAddress2: {
                      english: "Address2",
                    },
                    labelCity: {
                      english: "City",
                    },
                    labelState: {
                      english: "State",
                    },
                    labelZip: {
                      english: "Zip",
                    },
                    selectedState: null,
                    optionsState: [
                      { value: "", text: "State 1" },
                      { value: "", text: "State 2" },
                    ],
                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "personal-details-section":
          title = "Personal Details section " + ( length + 1 ) + " Title";
          newSection = {
            type: "personal-details",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "personal-details",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelTitle: {
                      english: "Title",
                    },
                    selectedTitle: null,
                    optionsTitle: [
                      { value: "1", text: "Mr" },
                      { value: "2", text: "Mrs" },
                      { value: "3", text: "Miss" },
                      { value: "4", text: "Ms" },
                      { value: "5", text: "Dr" },
                      { value: "6", text: "Sir" },
                      { value: "7", text: "Madam" },
                      { value: "8", text: "Lord" },
                      { value: "9", text: "Dame" },
                    ],
                    labelForeName: {
                      english: "Forename",
                    },
                    labelMiddelNames: {
                      english: "Middle name(s)",
                    },
                    labelLastName: {
                      english: "Last Name",
                    },
                    labelKnownAs: {
                      english: "Known As",
                    },
                    labelDateOfBirth: {
                      english: "Date of birth",
                    },
                    labelMaritalStatus: {
                      english: "Marital Status",
                    },
                    selectedMaritalStatus: null,
                    optionsMaritalStatus: [
                      { value: "1", text: "Single" },
                      { value: "2", text: "Married" },
                      { value: "3", text: "Separated" },
                      { value: "4", text: "Divorced" },
                      { value: "5", text: "Other" },
                    ],
                    labelDescribeBelow: {
                      english: "If other please describe below",
                    },
                    labelMobileContactNumber: {
                      english: "Mobile contact number",
                    },
                    labelPersonalEmailAddress: {
                      english: "Personal email address",
                    },
                    labelLinkedInProfile: {
                      english: "LinkedIn Profile",
                    },

                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "references-section":
          title = "References section " + ( length + 1 ) + " Title";
          newSection = {
            type: "references",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "references",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelRefereeName: {
                      english: "Referee name",
                    },
                    labelRefereePositionRole: {
                      english: "Referee Position/Role",
                    },
                    labelRefereeCompany: {
                      english: "Referee Company",
                    },
                    labelRefereeEmail: {
                      english: "Referee Email",
                    },
                    labelRefereePhone: {
                      english: "Referee Phone",
                    },
                    labelRefereeWebsite: {
                      english: "Referee website",
                    },
                    labelNatureOfRelationship: {
                      english: "Nature of relationship",
                    },
                    labelLengthOfRelation: {
                      english: "Length of relation",
                    },

                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "beneficial-owners-section":
          title = "Beneficial Owners section " + ( length + 1 ) + " Title";
          newSection = {
            type: "beneficial-owners",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "beneficial-owners",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelEntityName: {
                      english: "Entity name",
                    },
                    labelCompanyRegistration: {
                      english: "Company registration",
                    },
                    labelPercentageOwned: {
                      english: "Percentage owned (number)",
                    },
                    labelCountryOfRegistration: {
                      english: "Country of registration (country select)",
                    },

                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "share-holder-beneficial-owners":
          title =
            "Share holder Beneficial Owners section " + ( length + 1 ) + " Title";
          newSection = {
            type: "share-holder-beneficial-owners",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            sectionTitle: {
              english: title,
            },
            formElements: [
              {
                sectionIndex: length.toString(),
                inputType: "share-holder-beneficial-owners",
                id: uid(),
                name: "",
                label: {
                  english: "Select english Title",
                },
                fields: [
                  {
                    _id: uid(),
                    name: "",
                    value: "",
                    size: "",
                    labelIndividualName: {
                      english: "Individual name",
                    },
                    labelName: {
                      english: "Name (enter as per passport or ID card)",
                    },
                    labelPercentageOwned: {
                      english: "Percentage Owned",
                    },

                    validationMessage: {
                      english: "This field is required",
                    },
                  },
                ],
              },
            ],
          };
          break;

        case "section":
        default:
          title = "Section " + ( length + 1 ) + " Title";
          newSection = {
            type: "section",
            id,
            index: length,
            name: "",
            isRepeatable: false,
            advance: { hideSectionTitle: false },
            sectionTitle: {
              english: title,
            },
            formElements: [],
          };

          break;
      }
      this.ADD_SECTION( newSection );
    },

    async onSaveJsonData ( noToast ) {
      let formId = localStorage.getItem( "activeFormId" );
      // console.log("formIds", formId);
      // console.log("forms", this.form);
      if ( formId && this.form.formId ) {
        this.isLoadingLocal = true;
        let payload = this.form;
        // // console.log("payload", payload)
        let token = "Bearer " + localStorage.getItem( "accessToken" );
        try {
          let result = await HTTP( "put", "api/v1/form/edit/" + formId, payload, {
            Authorization: token,
          } );
          this.isLoadingLocal = false;
          if ( result && result.data ) {
            // let toUtc = moment.utc(result.data.updated_at.date).format();
            // // console.log("result.data", result)
            localStorage.setItem( "activeFormSchema", JSON.stringify( this.form ) );
            let toLocal = moment
              .utc( result.data.updated_at.date )
              .local()
              .format();
            // "YY-MMM-Do h:mm:ss a" // this will show year, month, day, date 12hr formatt
            let toFrom = moment( toLocal ).calendar();
            this.lastUpdatedTime = toFrom;
            if ( !noToast ) {
              Helper.makeToast( this.$bvToast, "success", "Form Save Success" );
            }
          }
        } catch ( error ) {
          this.isLoadingLocal = false;
          // console.log("error", error);
          if ( !noToast ) {
            Helper.makeToast(
              this.$bvToast,
              "danger",
              "Form not save please try again"
            );
          }
        } finally {
          this.isLoadingLocal = false;
        }
      }
    },

    tabClick ( tab ) {
      this.activeTab = tab;
      if ( tab == "BUILDER" ) {
        this.isBuilder = true;
      } else {
        this.isBuilder = false;
      }
    },
  },

  beforeDestroy () {
    this.clearFields();
    clearInterval( this.pushsing );
    // clearInterval(this.setLastUpdateInterval);
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
